import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  ThomasAdvertiser,
  ThomasCampaign,
  ProductFulfillment,
  ThomasCampaignProduct,
  AdServer
} from 'models/interfaces';

export const GET_CAMPAIGN_EDIT_DATA = gql`
  query GetCampaignEditData($tgramsId: ID!, $campaignId: String!) {
    advertiser: thomasAdvertiser(tgrams_id: $tgramsId) {
      name
      tgrams_id
    }
    campaign: thomasCampaign(campaign_id: $campaignId) {
      campaign_id
      name
      tgrams_id
      product_id
      start_date
      end_date
      status_id
      created_date
    }
    productFulfillment: productFulfillmentByCampaignId(campaign_id: $campaignId) {
      opportunity_id
      item_id
      tgrams_id
      product_sku
      quantity
      start_date
      end_date
      campaign_id
      configuration_workflow_arn
      configuration_activity_token
      order_source
      created_date
      last_updated_date
      last_updated_by
    }
    products: thomasCampaignProducts {
      product_id
      name
      abbreviation
      description
      created_date
      created_date
    }
    adServers {
      ad_server_id
      name
      description
    }
  }
`;

interface CampaignEditContainerRenderProps {
  advertiser: ThomasAdvertiser;
  campaign: ThomasCampaign;
  productFulfillment: ProductFulfillment;
  products: ThomasCampaignProduct[];
  adServers: AdServer[];
}

interface CampaignEditContainerProps {
  campaignId: string;
  tgramsId: string;
  children: (props: CampaignEditContainerRenderProps) => any;
}
const CampaignEditContainer: React.FC<CampaignEditContainerProps> = ({
  campaignId,
  tgramsId,
  children,
  ...props
}: CampaignEditContainerProps) => (
  <Query<CampaignEditContainerRenderProps>
    query={GET_CAMPAIGN_EDIT_DATA}
    variables={{ tgramsId, campaignId }}
    fetchPolicy="network-only"
  >
    {({
      data: { advertiser, campaign, productFulfillment, products, adServers } = {
        advertiser: {} as ThomasAdvertiser,
        campaign: {} as ThomasCampaign,
        productFulfillment: {} as ProductFulfillment,
        products: [] as ThomasCampaignProduct[],
        adServers: {} as AdServer[]
      },
      loading
    }) => {
      if (loading) {
        return null;
      }
      return (
        children &&
        children({
          ...props,
          advertiser,
          campaign,
          productFulfillment,
          products,
          adServers
        })
      );
    }}
  </Query>
);

export default CampaignEditContainer;
